import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    appLoc: '',
    app_conversation_id: '',
    firebaseToken: null,
    cToken: null,
    loginResponse: 'default'
  },
  mutations: {
    SET_LOC (state, loc) {
      state.appLoc = loc
    },
    SET_CONVERSATION_ID (state, conversation_id) {
      state.app_conversation_id = conversation_id
    },
    SET_C_TOKEN(state, token) {
      state.cToken = token
    },
    SET_FIREBASE_TOKEN(state, token) {
      state.firebaseToken = token
    },
    SET_LOGIN_RESPONSE(state, loginResponse) {
      state.loginResponse = loginResponse
    },
  },
  getters: {
    appLoc: state => state.appLoc,
    app_conversation_id: state => state.app_conversation_id,
    firebaseToken: state => state.firebaseToken,
    cToken: state => state.cToken,
    loginResponse: state => state.loginResponse,
  },
})

export default store


// WEBPACK FOOTER //
// ./src/store/index.js